import { FC, ReactNode } from "react";
import moment from "moment";
import { Loading02 } from "untitledui-js-base";
import { MenuSquareIcon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { Section } from "views/applications-id-report/components/Section";

interface IdentityVerificationRerunProgressViewProps {
  requestedAt?: string;
  actions?: ReactNode;
}

export const IdentityVerificationRerunProgressView: FC<
  IdentityVerificationRerunProgressViewProps
> = ({ requestedAt, actions }) => {
  const requestedAtLabel =
    requestedAt && moment(requestedAt).isValid()
      ? moment(requestedAt).format("MMM DD, YYYY, [at] h:mm A")
      : undefined;

  return (
    <Section
      sectionTitle="Identity verification summary"
      icon={
        <HugeiconsIcon
          icon={MenuSquareIcon}
          size="20px"
          strokeWidth={1.5}
          className="text-content-400"
        />
      }
      maxWidth="100%"
      sectionClassName="px-6 py-16"
    >
      <div className="flex flex-col items-center justify-center gap-6">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-warning-50">
          <Loading02 size="24px" className="stroke-warning-500" />
        </div>
        <div className="flex flex-col gap-2">
          <p className="text-center font-bold text-content-1000">
            Identity verification request was sent to the applicant
          </p>
          <p className="text-center text-sm text-content-300 max-w-[432px]">
            {requestedAtLabel
              ? `A request to retry identity verification has been sent to the applicant on ${requestedAtLabel}`
              : "A request to retry identity verification has been sent to the applicant"}
          </p>
        </div>
        {actions ? <div className="flex gap-2">{actions}</div> : null}
      </div>
    </Section>
  );
};
